import axios from 'axios';

const Api = () => {
  const getDocNumberInfoFetch = (docType: string, docNumber: string): Promise<unknown> =>
    axios.get(`${process.env.REACT_APP_GET_DOCNUMBER_INFO_URL}`, {
      params: {
        document_type: docType,
        document_value: docNumber
      }
    });

  const getZipCodeFetch = (zipCode: string | number): Promise<unknown> =>
    axios.get(`${process.env.REACT_APP_GET_ZIPCODE_INFO_URL}${zipCode}`);

  const confirmationFetch = (checkout: object): Promise<unknown> =>
    axios.post(`${process.env.REACT_APP_CHECKOUT_URL}orders`, checkout);

  const getPaymentUrl = (orderId: number | string) =>
    axios.get(`${process.env.REACT_APP_CHECKOUT_URL}orders/${orderId}`);

  return { getDocNumberInfoFetch, getZipCodeFetch, confirmationFetch, getPaymentUrl };
};

export default Api;
